import { Box, styled } from '@mui/material'

export const StyledBannerWrapper = styled(Box)(() => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
}))
